import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from "@angular/core";
import {SelectedFile} from "./selected-file.interface";

@Component({
  selector: "app-select-file",
  templateUrl: "./select-file.component.html",
  styleUrls: ["./select-file.component.scss"]
})
export class SelectFileComponent implements OnInit {
  @ViewChild("fileInput") fileInput: ElementRef;
  @Output() onSelectedFileListChanged: EventEmitter<Array<SelectedFile>> = new EventEmitter<Array<SelectedFile>>();
  @Input() buttonText: string;
  @Input() acceptedFileTypes: string = "image/*";
  @Input() isSingleSelect: boolean = false;

  constructor() {
  }

  ngOnInit() {
  }

  onInputChange(fileInput) {
    var files = fileInput.target.files;
    let fileList: Array<SelectedFile> = [];
    for (const file of files) {
      fileList.push({
        isValid: true,
        file: file
      });
    }
    this.onSelectedFileListChanged.emit(fileList);
    this.fileInput.nativeElement.value = ""
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/select-file/select-file.component.ts